// extracted by mini-css-extract-plugin
module.exports = {"root":"ShareLinks__root--38a4-","icon":"ShareLinks__icon--22Ec-"};